import React, { useEffect, useState } from "react";
import UserWrapper from "./DiagnosesCode.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import DiagnosesCodeServices from "../../api/DiagnosesCodeServices";
import DiagnosesCodeForm from "../../components/diagnosesCode/diagnosesCodeForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const DiagnosesCodeEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const hasParam = props.match.params.id;
  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      DiagnosesCodeServices.view(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    }
  }, []);

  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/diagnoses-code");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.diagnoses_code"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.diagnoses_code",
              url: "/diagnoses-code"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/diagnoses-code")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"}{" "}
              Diagnosis Code
            </div>
          </div>
          <div className="roe-card-body">
            <DiagnosesCodeForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(DiagnosesCodeEdit);
